import React, { FC } from 'react';
import { Button } from 'antd';
import { RouteComponentProps, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Path } from 'path-parser';

import { passwordReset } from '~/routes';

import { ResetPasswordFailIcon } from '~/img';
import PasswordResetLayout from '~/layout/PasswordResetLayout';

const path = new Path('/:route?token');

const PasswordResetOtherError: FC<RouteComponentProps> = () => {
  const { t } = useTranslation('passwordReset');
  const history = useHistory();
  const location = useLocation();
  const { token } = path.partialTest(location.pathname + location.search) || {};

  const onClick = () => {
    history.replace(`/${passwordReset}?token=${token}`);
  };

  return (
    <PasswordResetLayout
      icon={<ResetPasswordFailIcon />}
      title={t('Oops!')}
      subtitle={t('Something went wrong. Please try again.')}
      withGoToLogin
    >
      <Button type="primary" size="large" onClick={onClick}>
        {t('Try again')}
      </Button>
    </PasswordResetLayout>
  );
};

export default PasswordResetOtherError;
